module.exports = __webpack_public_path__ + "assets/img/bg5.d22adbd2.gif";